import instance from "@/services/api";

export const metricsAPI = {
  async getCommonResidents() {
    return await instance()
      .get("/common/residents/read/project/")
      .then((res) => res?.data);
  },
  async getProjectHeads() {
    return await instance()
      .get("/common/project_assigns/project_heads/read/")
      .then((res) => res?.data);
  },
  async getProjectSectionForemen() {
    return await instance()
      .get("/common/project_assigns/section_foremen/read/")
      .then((res) => res?.data);
  },
  async getMetrics(params) {
    return await instance()
      .get("/metrics/read", { params })
      .then((res) => res?.data);
  },
  async getMetricData(params) {
    return await instance()
      .get("/metrics/data/read", { params })
      .then((res) => res?.data);
  },
  async getMetricsDetails(params) {
    return await instance()
      .get("/metrics/okk/", { params })
      .then((res) => res?.data);
  },
  async getJobQueueJobs(params) {
    return await instance()
      .get("/metrics/job-queue/jobs/read/", { params })
      .then((res) => res?.data);
  },
  async getJobQueueGroups(params) {
    return await instance()
      .get("/metrics/job-queue/job-groups/read/", { params })
      .then((res) => res?.data);
  },
};
